/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.RegistrationController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { GetRegistrationResponse } from '../models/get-registration-response';

@Injectable()
export class RegistrationApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getRegistrations(spinnerMessage: string = null): Observable<GetRegistrationResponse> {
        return this.httpClient.get<GetRegistrationResponse>(`/api/registration`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getQrPdf(registrationNumber: number, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.get<void>(`/api/registration/qr/${registrationNumber}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


}
